export default "__VITE_ASSET__a6d15df2__"